import { InstagramIcon } from '@change/ds-icons';

import { Image, SocialIcon } from '@change/ds-core-ui/next';

import { SocialContentPreviewLoading } from '../SocialContentPreviewLoading';

type SocialContentPreviewProps = {
	shareVisual?: {
		url: string;
		variationName: string;
	};
	isLoading: boolean;
};

export function SocialContentPreview({ shareVisual, isLoading }: SocialContentPreviewProps) {
	if (isLoading || !shareVisual) {
		return <SocialContentPreviewLoading />;
	}

	return (
		<div className="relative h-[170px] w-[136px]">
			<SocialIcon
				aria-label="Instagram"
				icon={<InstagramIcon />}
				size="medium"
				variant="instagram"
				className="absolute -right-1 -top-1 border border-white"
				data-testid="instagram-icon"
			/>
			<Image src={shareVisual.url} alt={shareVisual.variationName} className="h-full w-full rounded-lg object-cover" />
		</div>
	);
}
